<template>
    <Button :variant="variant" size="big" @click="handleAdd">
        {{ $t("text-add-inspiration") }}
    </Button>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { useAuthStore } from '@stores/auth';
import { useSelectedStore } from '@stores/selected';
import Button from "@components/ui/button";

defineProps({
    variant: {
        type: String,
        default: 'accent'
    }
});

const { $eventBus } = useNuxtApp();

const auth = useAuthStore();
const store = useSelectedStore();

const handleAdd = async () => {
    $eventBus.emit('sidebar:close');
    if (auth.isLoggedIn) {
        await navigatorTo(translatePath(ROUTES.CODE.INSPIRATION_ADD));
    } else {
        store.setAction('ADD_NEW_INSPIRATION');
        $eventBus.emit('modal:open', 'LOGIN_VIEW');
    }
};

</script>
